import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function OverrideAlert() {
    return (<Alert appearance="info" message={t({
            message: 'You are editing multiple templates with different eSigning recipients',
            comment: 'Info message for editing default recipients for multiple templates with different eSigning recipients',
        })}/>);
}
